import { useEffect, useRef, useState } from 'react';

import useOverlayStatus from '../components/OverlayStatusContext/useOverlayStatus';
import postMessageToParent from '../helpers/postMessageToParent';

type ConfigureMessageType = { type: 'lb-configure'; openerUrl?: string };
type MessageType = ConfigureMessageType;

const useParentWindowCoordination = () => {
    const [openerUrl, setOpenerUrl] = useState<string>(window.location.href);
    const { enableParentRedirects } = useOverlayStatus();

    const handleConfigureRef = useRef((_data: ConfigureMessageType) => {});
    handleConfigureRef.current = (data: ConfigureMessageType) => {
        const url = data.openerUrl;
        if (!url) {
            return;
        }

        /**
         * If we've received the config message from the parent, that means
         * it supports client side redirects.
         */
        enableParentRedirects();

        setOpenerUrl(url);
    };

    useEffect(() => {
        postMessageToParent({ type: 'lb-load' });
    }, []);

    useEffect(() => {
        const handleMessage = (event: MessageEvent<MessageType>) => {
            switch (event.data.type) {
                case 'lb-configure':
                    handleConfigureRef.current(event.data);
                    break;
            }
        };

        window.addEventListener('message', handleMessage);

        return () => window.removeEventListener('message', handleMessage);
    }, []);

    return openerUrl;
};

export default useParentWindowCoordination;
